export const menuItem = {
  active: '#0C1217',
};
